import { Col, Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { LocaleStringsListFilter } from "./LocaleStringListFilter";
import { useLocaleStrings } from "../../hooks/localestrings/useLocaleStrings";
import { ControlcenterMelcoModelsLocaleStringListItem } from "melco-shared-logic";
import { TableCellLink } from "../table/TableCellLink";
import { EditLocaleStringDrawer } from "./drawer/EditLocaleStringDrawer";
import { LocaleStringsListFiltersType } from "../../hooks/localestrings/LocaleStringsListFilterType";

type LocaleStringsListPropTypes = {};

export const LocaleStringsList: React.FC<LocaleStringsListPropTypes> = () => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    filtersChange,
    refetch,
  } = useLocaleStrings();

  const { t } = useTranslation();

  const [isEditDrawerOpen, setEditDrawerOpen] = useState(false);
  const [editLocaleStringDetails, setEditLocaleStringDetails] =
    useState<ControlcenterMelcoModelsLocaleStringListItem>();
  const [localeStringsListFiltersValues, setLocaleStringsListFiltersValues] =
    useState<LocaleStringsListFiltersType>();

  const setEditDrawerAction = (action: boolean) => {
    setEditDrawerOpen(action);
    refetch();
  };

  const handleEditClick = (
    item: ControlcenterMelcoModelsLocaleStringListItem
  ) => {
    setEditLocaleStringDetails(item);
    setEditDrawerAction(true);
  };

  const columns = [
    {
      title: t("localestrings.table.column.id"),
      key: "id",
      //dataIndex: "id",
      sorter: true,
      width: 15,
      render: (rowObj: ControlcenterMelcoModelsLocaleStringListItem) => (
        <TableCellLink
          onClick={() => {
            handleEditClick(rowObj);
          }}
          to={""}
        >
          {rowObj.id}
        </TableCellLink>
      ),
    },
    {
      title: t("localestrings.table.column.module"),
      key: "module",
      dataIndex: "module",
      sorter: true,
      width: 11,
    },
    {
      title: t("localestrings.table.column.key"),
      key: "key",
      dataIndex: "key",
      sorter: true,
      width: 25,
    },
    {
      title: t("localestrings.table.column.source"),
      key: "source",
      dataIndex: "source",
      sorter: true,
      width: 30,
    },
    {
      title: t("localestrings.table.column.text"),
      key: "text",
      dataIndex: "text",
      sorter: true,
      width: 30,
    },
  ];

  return (
    <>
      <TableActionBarRow>
        <div></div>
        <Col xs={24} xl={17}>
          <LocaleStringsListFilter
            refetch={refetch}
            onFiltersChange={filtersChange}
            setLocaleStringsListFiltersValues={
              setLocaleStringsListFiltersValues
            }
          />
        </Col>
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="id"
        // rowSelection={rowSelection}
        // onRow={onRow}
        noDataMessage={t("localestrings.basic.no_localestrings_message")}
        errorComponent={errorComponent}
        //scroll={{ x: 1700 }}
      />
      {isEditDrawerOpen && editLocaleStringDetails && (
        <EditLocaleStringDrawer
          isDrawerOpen={isEditDrawerOpen}
          setDrawerOpen={setEditDrawerAction}
          LocaleStringDetails={editLocaleStringDetails}
          localeStringsListFiltersValues={localeStringsListFiltersValues}
        />
      )}
    </>
  );
};
